import React from 'react';

export default function GuestSignInLogo({ fillColor, }) {
  return (
    <svg
      style={{ cursor: 'pointer' }}
      className={'guest-log-in-icon'}
      viewBox='0 0 64.25 66.83'>
      <path
        fill={fillColor}
        d='M32.13,27.57c-7.6,0-13.78-6.18-13.78-13.78S24.53,0,32.13,0s13.78,6.18,13.78,13.78-6.18,13.78-13.78,13.78Z'
      />
      <path
        fill={fillColor}
        d='M63.97,66.83H.28l-.17-2.02c-.08-.95-.12-1.81-.12-2.63C0,44.47,14.41,30.06,32.13,30.06s32.13,14.41,32.13,32.13c0,.81-.04,1.67-.12,2.63l-.16,2.02Z'
      />
    </svg>
  );
}
